<template>
    <div class="book-element-list" tabindex="0" ref="hyperlinklist" @focus="focus" @keyup.enter="keyup">
    <div class="page" :tabindex="tabIndex" @focus="focusInner" @keyup.enter="keyupInner" v-for="(page, index) in hyperlinks" :key="index" :ref="`page${page.pageNumber}`">
      <router-link :tabindex="subTabIndex" class="page-link" :title="`Gå til side ${page.pageNumber}`" :to="{ name: 'Page', params: { pageNumber: page.pageNumber }}">Side {{ page.pageNumber }}</router-link>
      <ul>
        <li v-for="(hyperlink, index) in page.hyperlinks" :key="index">
          <a :tabindex="subTabIndex" :href="hyperlink.url" target="_blank" :title="hyperlink.description">
            <t-icon name="icon-link" /> {{ hyperlink.name }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import bookTools from '@/utils/book'
export default {
  data () {
    return {
      active: false,
      click: false,
      tabIndex: -1,
      subTabIndex: -1
    }
  },
  activated () {
    this.scrollToActive()
    this.active = true
  },
  deactivated () {
    this.active = false
  },
  methods: {
    scrollToActive () {
      let pageNumber = this.pageNumber
      if (!bookTools.isEven(pageNumber)) {
        pageNumber = pageNumber - 1
      }
      const closestPageNumber = bookTools.closestNumber(pageNumber, this.hyperlinks.map(a => a.pageNumber))

      if (closestPageNumber) {
        const el = (this.$refs[`page${closestPageNumber}`] || [])[0]
        if (el !== null && el !== undefined) {
          const parentEl = this.$refs.hyperlinklist.parentElement.parentElement
          parentEl.scrollTop = el.offsetTop
          if (parentEl.scrollTop === el.offsetTop) {
            parentEl.scrollTop -= 40
          }
        }
      }
    },
    focus () {
      this.tabIndex = -1
    },
    focusInner () {
      this.subTabIndex = -1
    },
    keyup () {
      this.tabIndex = 0
    },
    keyupInner () {
      this.subTabIndex = 0
    }
  },
  computed: {
    hyperlinks () {
      return this.$store.getters.hyperlinks
    },
    pageNumber () {
      return this.$route.params.pageNumber
    }
  },
  watch: {
    '$store.getters.leftMenuOpen' (newVal) {
      if (newVal && this.active) {
        this.scrollToActive()
      }
    },
    pageNumber () {
      if (this.active && !this.click) {
        setTimeout(() => {
          this.scrollToActive()
        }, 100)
      }
      this.click = false
    }
  }
}
</script>

<style>

</style>
